var React = require('react');

function Iphone (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"4"},[React.createElement("rect",{"height":"84.95","rx":"4.51","width":"44.65","x":"2","y":"2","key":0}),React.createElement("path",{"d":"m2.05 11.67h44.55","key":1}),React.createElement("path",{"d":"m2.05 68.98h44.55","key":2}),React.createElement("circle",{"cx":"24.33","cy":"77.88","r":"3.15","key":3})]));
}

Iphone.defaultProps = {"viewBox":"0 0 48.65 88.95"};

module.exports = Iphone;

Iphone.default = Iphone;
